class HeadingWithScroll extends HTMLElement {
    constructor() {
        super();
        const originalThis = this;
        const scrollElem = document.querySelector('.heading-with-scroll-list');
        scrollElem.addEventListener('scroll', function (e) {
            const scrollValue = window.innerWidth < 768 ? e.target.scrollLeft : e.target.scrollTop;
            if (scrollValue > 0) {
                originalThis.toggleScrollRemove();
            } else {
                originalThis.toggleScrollShow();
            }
        });
    }

    toggleScrollRemove() {
        document.querySelector('.heading-with-scroll__overlay').classList.add('heading-with-scroll__overlay--faded');
    }

    toggleScrollShow() {
        document.querySelector('.heading-with-scroll__overlay').classList.remove('heading-with-scroll__overlay--faded');
    }
}

customElements.define('heading-with-scroll', HeadingWithScroll);
